<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized && paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Accepted]" class="container-fluid space-1">
  <form #myForm="ngForm">
    <h3 class="text-center">Congratulations!</h3>
    <h5 class="text-center">
      Your {{paper.paperTypeName}}: <strong>{{ paper.title }}</strong> has been Accepted!
    </h5>
    <div class="mt-5 text-center">
      <p *ngIf="paper.ceuInstructorName">
        You listed <strong>{{ paper.ceuInstructorName }}</strong> as your CEU instructor for your {{paper.paperTypeName}}. Is this person still your CEU instructor? <br /><strong>They should adhere to ALL qualifications listed on page 5 of the BACB ACE Provider Handbook.</strong>
      </p>
      <p *ngIf="!paper.ceuInstructorName"><strong>You have no CEU instructor listed.</strong></p>
      <p><small>If you don't have a CEU instructor, we can assign one for you.</small></p>
      <select class="form-control-lg" [(ngModel)]="instructorStatus" required name="instructorStatus" style="width: 500px">
        <option [ngValue]="null">Please Choose...</option>
        <option *ngIf="paper.ceuInstructorName" [ngValue]="1">Yes. {{ paper.ceuInstructorName }} is still our CEU instructor.</option>
        <option *ngIf="paper.ceuInstructorName" [ngValue]="0">No. We have a different CEU instructor.</option>
        <option *ngIf="!paper.ceuInstructorName" [ngValue]="0">We now have a CEU instructor.</option>
        <option [ngValue]="2">We have no CEU instructor. Please assign one.</option>
        <option [ngValue]="2">We are not offering CEUs.</option>
      </select>
      <div class="invalid-message">
        <div>Please make a selection</div>
      </div>
      <div *ngIf="instructorStatus == 0" class="row mt-2">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <label for="firstName">Who is the CEU Instructor for this {{ paper.paperTypeName }}?</label>
          <input type="text" [(ngModel)]="model.ceuInstructor" required name="ceuInstructorName" required class="form-control" />
          <div class="invalid-message">
            <div>CEU Instructor is required</div>
          </div>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <div class="mt-5 text-center">
      <h5>Are you still able to present this {{paper.paperTypeName}}?</h5>
      <p>By finalizing your {{paper.paperTypeName}}, you agree that you and all your presenters will register for the conference.</p>
      <button type="button" (click)="finalizePaper(false)" class="btn btn-danger mr-2">Withdraw {{paper.paperTypeName}}</button>
      <button type="button" (click)="finalizePaper(true)" class="btn btn-success">Finalize {{paper.paperTypeName}}</button>
    </div>
  </form>
</div>
<div *ngIf="initialized && paper.paperApprovalStatus.toString() != PaperApprovalStatus[PaperApprovalStatus.Accepted] && paper.paperApprovalStatus.toString() != PaperApprovalStatus[PaperApprovalStatus.Finalized] && paper.paperApprovalStatus.toString() != PaperApprovalStatus[PaperApprovalStatus.Withdrawn]" class="container-fluid space-1">
  <div class="alert alert-danger text-center">
    <h5>This link has expired or is no longer valid.</h5>
  </div>
</div>
<div *ngIf="initialized && (paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Finalized] || paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Withdrawn])" class="container-fluid space-1">
  <div class="alert alert-success text-center">
    <h3>Paper Finalized</h3>
    <h5>This {{paper.paperTypeName}} has been finalized! No further action is required at this time.</h5>
  </div>
</div>
